import { render } from "./About.vue?vue&type=template&id=64558cd1"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render

export default script